import ApiServiceV2 from 'services/apiService/apiServiceV2';

const orderEndpoint = orderId =>
	`/orders/${encodeURIComponent(orderId)}/material-validation`;

export const getMaterialValidation = (orderId, { controlSignal } = {}) =>
	ApiServiceV2.get({
		url: orderEndpoint(orderId),
		...(controlSignal ? { controlSignal } : {}),
	});

export const requestManualMaterialCorrection = (
	orderId,
	payload,
	{ idempotencyKey, controlSignal } = {},
) =>
	ApiServiceV2.post({
		url: `${orderEndpoint(orderId)}/correction-requests`,
		data: payload,
		headers: {
			'Idempotency-Key': idempotencyKey,
		},
		...(controlSignal ? { controlSignal } : {}),
	});

export const decideMaterialValidation = (
	orderId,
	caseId,
	payload,
	{ version, idempotencyKey, controlSignal } = {},
) =>
	ApiServiceV2.post({
		url: `${orderEndpoint(orderId)}/cases/${encodeURIComponent(caseId)}/decisions`,
		data: payload,
		headers: {
			'If-Match': String(version),
			'Idempotency-Key': idempotencyKey,
		},
		...(controlSignal ? { controlSignal } : {}),
	});
